jQuery( document ).ready(function($) {
    if(typeof $.fancybox == 'function') {
        $('[data-fancybox]').fancybox({
            youtube : {
                rel : 0,
                modestbranding : 1,
                controls : 1,
                showinfo : 0,
                iv_load_policy : 3
            }
        });
    }
});